import Modal from "@/src/components/Modal";
import status from "../../assets/img/IconStatus.png";

import Icons from "@/src/components/Icons";
interface helpProps {
  open: any;
  close: any;
}
function HelpMoldal({ open, close }: helpProps) {
  return (
    <Modal open={open} onClose={close}>
      <div className="text-center">
        <div className="title text-xl font-bold my-2">راهنما</div>
        <p className="text-center text-sm text-[#A5A5A5] mb-4">
          برای ارسال سفارش‌ها، آیکون‌هایی در سه رنگ روی هر کارت ارسال قرار گرفته
          که نشان‌دهنده وضعیت پیک است. این وضعیت‌ها به شرح زیر است:
        </p>
      </div>
      <img src={status} alt="" className="w-full" />
      <div className="mt-4">
        <div className="header bg-white rounded-xl shadow-mmpz flex justify-between px-2 py-3">
          <div className="item w-1/3 text-sm text-center">آیکون</div>
          <div className="item w-1/3 text-sm text-center">نام وضعیت</div>
          <div className="item w-1/3 text-sm text-center">توضیحات</div>
        </div>
        <div className="flex justify-between px-2 flex-wrap mt-4 items-center pb-10">
          <div className="item w-1/3 flex justify-center">
            <Icons name="deliveryStatusAccess" size={40} />
          </div>
          <div className="item w-1/3 flex justify-center text-xs text-[#4B4B4B]">
            در مسیر مبدا
          </div>
          <div className="item w-1/3 flex justify-center text-xs text-[#4B4B4B]  text-center">
            در این وضعیت پیک تا دقایقی دیگر برای دریافت مرسوله به مبدا می‌رسد.
          </div>
          <div className="item w-1/3 flex justify-center mt-8">
            <Icons name="deliveryStatusPending" size={40} />
          </div>
          <div className="item w-1/3 flex justify-center text-xs text-[#4B4B4B] mt-8">
            در مبدا است
          </div>
          <div className="item w-1/3 flex justify-center text-xs text-[#4B4B4B] mt-8 text-center">
            در این وضعیت پیک به مبدا رسیده است و آماده دریافت مرسوله است.{" "}
          </div>
          <div className="item w-1/3 flex justify-center mt-8">
            <Icons name="deliveryStatusCancel" size={40} />
          </div>
          <div className="item w-1/3 flex justify-center text-xs text-[#4B4B4B] mt-8">
            لغو شد
          </div>
          <div className="item w-1/3 flex justify-center text-xs text-[#4B4B4B] mt-8 text-center">
            این وضعیت به معنای لغو درخواست از سوی پیک یا پشتیبانی مامان‌پز است.{" "}
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default HelpMoldal;
